import { asyncRoute } from '../../router';

export default asyncRoute(() =>
  import(/* webpackChunkName: "ResetPasswordContainer" */ './container/ResetPasswordContainer')
);
